import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LOCALES } from '../constants/locales';
import { useCountry } from '../context/CountryContext';

export default function WelcomeCountryModal() {
    const { t, i18n } = useTranslation();
    const { setCountry } = useCountry();
    const [visible, setVisible] = useState(() => !localStorage.getItem('countrySelected'));

    if (!visible) return null;

    function selectLocale(locale) {
        i18n.changeLanguage(locale.code);
        setCountry(locale.country);
        localStorage.setItem('countrySelected', 'true');
        setVisible(false);
    }

    return (
        <div className='welcome-modal'>
            <div className='welcome-modal__backdrop'></div>
            <div className='welcome-modal__dialog'>
                <p className='welcome-modal__title'>{t('welcomeModal.title', 'Wybierz swój kraj')}</p>
                <ul className='welcome-modal__list'>
                    {LOCALES.map(locale => (
                        <li key={locale.code}>
                            <button type='button' className='welcome-modal__option' onClick={() => selectLocale(locale)}>
                                <img
                                    src={`https://flagcdn.com/24x18/${locale.countryCode}.png`}
                                    alt={locale.label}
                                    className='welcome-modal__flag'
                                />
                                {locale.label}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
